import React, { useState } from 'react';
import { Input, Button, Row } from 'antd';
import { Spacing } from 'works/legacy/lib/style-helper';

type SearchValue = string | undefined | null;

export const TextFilterSearch = ({
  id,
  onChange,
  onSearch,
  defaultValue,
  placeHolder,
  autoFocus,
}: {
  id?: string;
  onSearch: (value: SearchValue) => void;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: SearchValue
  ) => void;
  defaultValue?: SearchValue;
  placeHolder?: string;
  autoFocus?: boolean;
}) => {
  const [queryString, setQueryString] = useState(defaultValue);

  return (
    <>
      <Input
        id={id}
        autoFocus={autoFocus}
        placeholder={placeHolder || 'Search'}
        onChange={(event) => {
          const value = event.target.value;

          setQueryString(value);
          onChange?.(event, value);
        }}
        value={queryString ?? undefined}
        onPressEnter={() => {
          onSearch(queryString);
          setQueryString(null);
        }}
        style={{
          width: 188,
          marginBottom: Spacing.baseSpacing / 2,
          display: 'block',
        }}
      />
      <Row justify="end">
        <Button
          type="primary"
          onClick={() => {
            onSearch(queryString);
            setQueryString(null);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Apply
        </Button>
      </Row>
    </>
  );
};
